import { SkillJobQualification } from "common/models";
import { Qualification } from "common/models/QualificationCategoryType";
import * as React from "react";

interface SkillJobQualificationListProps {
    skillJobQualifications: SkillJobQualification[];
}

export const SkillJobQualificationList: React.FC<SkillJobQualificationListProps> = (
    props: SkillJobQualificationListProps
) => {
    const { skillJobQualifications } = props;

    const getSkillJobQualifications = (
        skillJobQualification: SkillJobQualification
    ) => {
        let anyAllOf = "";
        if (
            Qualification.fromId(
                skillJobQualification.qualification_id
            )?.isSkillAllOf() &&
            skillJobQualification.skill_choices.length > 1
        ) {
            anyAllOf = "of experience in ALL of the following:";
        } else if (
            Qualification.fromId(
                skillJobQualification.qualification_id
            )?.isSkillAnyOf()
        ) {
            anyAllOf = "of experience in ANY of the following:";
        }

        if (anyAllOf === "") {
            return (
                <>
                    {`${skillJobQualification.skill_choices[0].skill_choice_text} (${skillJobQualification.years_of_experience_tag_name})`}
                </>
            );
        } else {
            return (
                <>
                    {`${skillJobQualification.years_of_experience_tag_name} ${anyAllOf}`}
                    <ul className="c-quals-child-list">
                        {skillJobQualification.skill_choices.map(choice => (
                            <li
                                style={{ padding: 0 }}
                                key={choice.skill_choice_id}
                                className="c-job-detail__li"
                            >
                                {choice.skill_choice_text}
                            </li>
                        ))}
                    </ul>
                </>
            );
        }
        return null;
    };

    return (
        <React.Fragment>
            {skillJobQualifications.map(skillJobQualification => (
                <li
                    style={{ padding: 0 }}
                    key={`${skillJobQualification.job_qualification_id}`}
                >
                    {getSkillJobQualifications(skillJobQualification)}
                </li>
            ))}
        </React.Fragment>
    );
};

export default SkillJobQualificationList;
